import React from "react"
import styled from 'styled-components'
import { sizes, fonts, colors, breakpoints } from '../css-variables'
import LeftBG from '../../svg/left_bg.svg'
import RightBG from '../../svg/right_bg.svg'

const AdviceComments = ({ className, comments }) => {

    return (
      <div className={className}>
        <div className="bg-img left-bg"></div>
        <div className="bg-img right-bg"></div>
        <ul>
          {comments?.nodes.map(comment => {
            return(
              <li key={comment.id}>
                <div dangerouslySetInnerHTML={{ __html: comment.content }}></div>
                <p className="attribution" dangerouslySetInnerHTML={{ __html: comment.author.node.name }}></p>
              </li>
            )
          })}
        </ul>
      </div>
    )
 
}

const StyledAdviceComments = styled(AdviceComments)`
  max-width: 1080px;
  margin: 58px 30px;
  ul{
    display: flex;
    gap: 1.2rem;
    margin: 0;
    flex-wrap: wrap;
    justify-content: space-between;
    li{
      list-style: none;
      width: 100%;
      padding: ${sizes.s48};
      background-color: ${colors.badgerRed};
      color: ${colors.titleWhite};
      font-size: 28px;
      line-height: 36px;
      font-family: ${fonts.eaves};
      font-style: italic;
      font-weight: 600;
      text-align:center;
      display:flex;
      justify-content: center;
      flex-direction: column;
      max-width: 500px;
      margin: 0 auto;

      &:nth-child(even){
        background-color: ${colors.calloutGrey};
        color: ${colors.badgerRed};
      }
      p.attribution{
        font-family: ${fonts.redHatText};
        font-size: ${sizes.s14};
        font-style: normal;
        text-transform: uppercase;
        margin-top: 12px;

      }
    }
  }
  .bg-img{
    display: none;
    position: absolute;
    background-repeat:no-repeat;
    z-index: -2;
  }
  .left-bg{
    background-image: url(${LeftBG});    
    width: 996.55px;
    height: 1011.22px;
    left: 0;
    top: 550px;
  }
  .right-bg{
    background-image: url(${RightBG});    
    width: 707.55px;
    height: 1011.22px;
    right: 0;
    top: 1100px;
  }

  @media screen and ${breakpoints.tabletS} {
    .left-bg{
      display: block;
    }
  }
  @media screen and ${breakpoints.tabletL} {
    .right-bg{
      display: block;
    }
    ul{
      li{
        width: calc(50% - 1.2rem);
        min-height: 334px;
        max-width: unset;
        margin: unset;
        &:nth-child(2), &:nth-child(3), &:nth-child(4n+2), &:nth-child(4n+3){
          background-color: ${colors.calloutGrey};
          color: ${colors.badgerRed};
        }
        &:nth-child(4n+4){
          background-color: ${colors.badgerRed};
          color: ${colors.titleWhite};
        }
      }
    }
  }
  @media screen and ${breakpoints.laptopS} {
    margin: 58px auto;
  }
`
export default StyledAdviceComments


